import { Component, Input } from '@angular/core';

@Component({
  selector: 'psc-info-card',
  templateUrl: './info-card.component.html'
})
export class InfoCardComponent {
  @Input() icon: string;
  @Input() matIcon: string;
  @Input() image: string;
  @Input() imageAlt: string;
  @Input() title: string;
  @Input() text: string = 'Cras orci lacus, pellentesque in condimentum eu, aliquam a nisi. Lorem ipsum dolor sit amet, consectetur adipiscing elit.';
}
